import { createFileRoute } from '@tanstack/react-router';

import { LogoutPage } from '../features/auth/LogoutPage';

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
});
